import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class MatchingScore extends AdornisEntity {
  static override _class = 'MatchingScore';

  constructor(doc: PartialEntityData<MatchingScore>) {
    super(doc);
  }

  // Total score 0..100
  @Field(() => Int)
  total: Maybe<number>;

  // Weighted (0..100 each)
  @Field(() => Int)
  weightedSkills: Maybe<number>;

  @Field(() => Int)
  weightedLanguages: Maybe<number>;

  @Field(() => Int)
  weightedSoftSkills: Maybe<number>;

  @Field(() => Int)
  weightedExperience: Maybe<number>;

  @Field(() => Int)
  weightedPosition: Maybe<number>;

  // Raw (0..1 each)
  @Field(() => Float)
  rawSkills: Maybe<number>;

  @Field(() => Float)
  rawLanguages: Maybe<number>;

  @Field(() => Float)
  rawSoftSkills: Maybe<number>;

  @Field(() => Float)
  rawExperience: Maybe<number>;

  @Field(() => Float)
  rawPosition: Maybe<number>;

  // Diagnostics
  @Field(() => [String])
  notes: Maybe<string[]>;
}
